/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import blog1 from '../images/blog1.jpg'
import blog2 from '../images/blog2.jpg'
import blog3 from '../images/blog3.jpg'
import blog4 from '../images/blog4.jpg'
import '../style/blog.css'
const LatestBlog = () => {
    return (
        <>
            <section id='blog'>
                <div className="container" style={{ textAlign: 'center' }}>
                    <h3 style={{ color: 'rgb(13 92 126)' }}>LATEST PUBLICATIONS</h3>
                </div>
                <div className='container' style={{ marginTop: '40px' }}>
                    <div className='row' style={{ textAlign: 'center' }}>
                        <div className='col'>
                            <figure>
                                <img id='imgB' src={blog1} width={'300px'} height={'225px'} alt="blogImage" />
                                <h5 style={{ marginTop: '25px', color: '#040f2e' }}>Stop Ignoring These 7 Inspiring Truths</h5>
                                <h6>OCTOBER 14, 2018</h6>
                            </figure>
                        </div>
                        <div className='col'>
                            <figure>
                                <img id='imgB' src={blog2} width={'300px'} height={'225px'} alt="blogImage" />
                                <h5 style={{ marginTop: '25px', color: '#040f2e' }}>How to be 1% Better Every Day</h5>
                                <h6>OCTOBER 14, 2018</h6>
                            </figure>
                        </div>
                        <div className='col'>
                            <figure>
                                <img id='imgB' src={blog3} width={'300px'} height={'225px'} alt="blogImage" />
                                <h5 style={{ marginTop: '25px', color: '#040f2e' }}>How To Become Ridiculously Self-Aware In 20 Minutes</h5>
                                <h6>OCTOBER 13, 2018</h6>
                            </figure>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default LatestBlog
